import { Field } from 'react-final-form';
import { Grid2, Tooltip } from '@mui/material';

import { PaymentPlatform } from '@utriper/core';
import { CheckboxComponent as Checkbox } from '@utriper/core-ui';

import { useTranslation } from 'core/contexts/localization';

export function PaymentPlatformCheckList({ isHost, isTourOperator, canEdit, checked, onChange }) {
    const { t: translate, i18n } = useTranslation();
    const lang = i18n.language?.substring(0, 2);
    const normalizedLang = lang === 'es' || lang === 'en' ? lang : 'en';
    const supportedIds = PaymentPlatform.getSupportedPlatformIds({ isHost, isTourOperator });

    return Object.values(PaymentPlatform.TYPES)
        .filter((platform) => supportedIds.includes(platform.id))
        .map((platform) => {
            const platformName = platform?.xlat?.[normalizedLang]?.name ?? platform?.xlat?.en?.name ?? '';
            const platformDesc = platform?.xlat?.[normalizedLang]?.desc ?? platform?.xlat?.en?.desc ?? '';

            return (
                <Grid2 key={platform.id} size={{ xs: 12 }}>
                    <Tooltip placement="right" title={platformDesc}>
                        <Field
                            style={{
                                paddingTop: '0',
                            }}
                            disabled={!canEdit}
                            checked={checked(platform.id)}
                            onChange={(value) => {
                                onChange(value, platform.id);
                            }}
                            name={platform.name}
                            component={Checkbox}
                            labelComponent={translate('host.acceptPaymentPlatform', { platform: platformName })}
                        />
                    </Tooltip>
                </Grid2>
            );
        });
}
